import { Grid } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { limitsOptions } from "components/Layout/Campaign/utils/utils";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import _ from "lodash";
import { FEWalletTypeFormat } from "types/wallets";
import { useStyles } from "./WalletType.styles";

export interface SelectedLimitType {
  interval: { type: string; value?: number };
  value?: number;
}

type LimitsPathPrefixes = "points" | "pointsPerMember";

const getIntervalTypeLabel = (type: LimitsPathPrefixes): string => {
  switch (type) {
    case "points":
      return "globalUnitsLimitation";
    case "pointsPerMember":
      return "memberUnitsLimitation";
    default:
      return "";
  }
};

const getValueLabel = (type: LimitsPathPrefixes): string => {
  switch (type) {
    case "points":
    case "pointsPerMember":
      return "unitsLimit";
    default:
      return "";
  }
};

export function LimitsSubSection(props: {
  editMode?: boolean;
  pathPrefix: LimitsPathPrefixes;
  "data-test-id": string;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const { values } = useFormikContext<FEWalletTypeFormat>();
  const value = _.get(values, `limits.${props.pathPrefix}.interval.type`);

  return (
    <div className={classes.TooltipWrapper}>
      <Grid container spacing={10}>
        <Grid xs item>
          <SelectInput
            className={classes.fullWidth}
            data-test-id={`${props["data-test-id"]}-units-select`}
            items={limitsOptions.map(
              (
                option,
              ): {
                id: string;
                label: string;
              } => ({
                id: option.value,
                label: message({ id: option.label }),
              }),
            )}
            label={message({
              id: getIntervalTypeLabel(props.pathPrefix),
            })}
            name={`limits.${props.pathPrefix}.interval.type`}
          />
        </Grid>
        {value !== "noLimit" && value && (
          <Grid xs item>
            <NumberFormatInput
              data-test-id={`${props["data-test-id"]}-units-value-input`}
              label={
                <RequiredFieldLabel
                  text={message({
                    id: getValueLabel(props.pathPrefix),
                  })}
                />
              }
              name={`limits.${props.pathPrefix}.value`}
              width="100%"
            />
          </Grid>
        )}
      </Grid>
    </div>
  );
}
